import { useEffect, useState } from 'react';

const inputClass = 'mt-2 w-full border border-[#383142] bg-[#0f0d14] px-3 py-2.5 text-sm text-[#f2edf5] outline-none transition focus:border-[#b66ee3] focus:ring-2 focus:ring-[#8e4bb5]/20';
const labelClass = 'block text-[10px] font-bold uppercase tracking-[.14em] text-[#afa2b9]';

const clone = (value) => JSON.parse(JSON.stringify(value));

export default function HiddenPointsEditor({ resource, onSave, onReset, isSaving, error, notice }) {
  const [draft, setDraft] = useState(() => clone(resource.config));
  useEffect(() => setDraft(clone(resource.config)), [resource]);

  const update = (key, value) => setDraft((current) => ({ ...current, [key]: value }));
  const formattedUpdate = resource.meta.updatedAt
    ? new Date(resource.meta.updatedAt).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' })
    : 'Sin cambios guardados';

  return (
    <form onSubmit={(event) => { event.preventDefault(); onSave(draft); }} className="mx-auto max-w-[1480px] px-5 py-7 lg:px-8">
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-[#312a3a] pb-5">
        <div>
          <p className="font-mono text-[9px] uppercase tracking-[.2em] text-[#a887b9]">Módulo · Mapa</p>
          <h2 className="mt-1 font-display text-4xl uppercase text-[#f3edf6]">Puntos ocultos</h2>
          <p className="mt-2 max-w-xl text-xs leading-5 text-[#8f8298]">
            Cada fantasmita encontrado con un clic real acredita estos puntos en el servidor.
            Sin el código de la hora (estilo TOTP, atado a jugador + punto) no hay puntos:
            una petición suelta al API no puede farmear. Cada hora en punto todo se
            regenera en los mismos lugares para todos; los secretos rotan cada 24 h.
          </p>
        </div>
        <div className="text-right font-mono text-[9px] leading-5 text-[#84768d]">
          <p>{resource.meta.source === 'defaults' ? 'Usando valores predeterminados' : `Versión ${resource.meta.version}`}</p>
          <p>{formattedUpdate}</p>
        </div>
      </div>

      <div className="mt-7 grid gap-5 border border-[#312a3a] bg-[#121019]/80 p-5 sm:grid-cols-2 sm:p-6">
        <label className={labelClass}>Puntos por fantasmita (1–100)
          <input type="number" min="1" max="100" step="1" value={draft.pointsPerFind} onChange={(event) => update('pointsPerFind', Number(event.target.value))} className={inputClass} />
        </label>
        <label className={labelClass}>Gesto mínimo en ms (0–2000, 0 = sin mínimo)
          <input type="number" min="0" max="2000" step="1" value={draft.minGestureMs} onChange={(event) => update('minGestureMs', Number(event.target.value))} className={inputClass} />
        </label>
      </div>

      {(error || notice) && <div className={`mt-5 border-l-2 px-4 py-3 text-sm ${error ? 'border-[#ef7f8f] bg-[#2b1219] text-[#ffd8de]' : 'border-[#7dd6ae] bg-[#0d251d] text-[#c8f6df]'}`} role="status">{error || notice}</div>}
      <div className="mt-6 flex flex-col-reverse gap-3 border-t border-[#312a3a] pt-5 sm:flex-row sm:justify-between">
        <button type="button" onClick={onReset} disabled={isSaving} className="px-3 py-3 text-xs font-bold text-[#baacbf] underline decoration-[#65546f] underline-offset-4 disabled:opacity-40">Restaurar valores predeterminados</button>
        <button type="submit" disabled={isSaving} className="border border-[#d8b6ee] bg-[#754196] px-8 py-3.5 text-xs font-black uppercase tracking-[.15em] text-white shadow-[4px_4px_0_#050407] transition active:translate-x-0.5 active:translate-y-0.5 disabled:opacity-45">{isSaving ? 'Guardando…' : 'Guardar cambios'}</button>
      </div>
    </form>
  );
}
